<template>
  <div class="share-page">
    <div class="share-container">
      <div v-show="isWeixin && showModel" class="weixin-tip">
        <img @click="showModel = false" src="@/assets/img/weixin-tip.jpg" class="weixinpic" alt="微信打开" />
      </div>
      <div class="title-img">
        <div class="img-in"></div>
        <!-- <img src="~@/assets/img/pic_share_logo.png" alt="灵云听语logo" srcset="@/assets/img/pic_share_logo@2x.png 2x, @/assets/img/pic_share_logo@3x.png 3x"> -->
      </div>
      <div class="audio-control">
        <div @click="audioPlay" class="play-icon" :class="isPlay ? 'pause' : 'play'"></div>
        <div class="play-slider">
          <van-slider v-model="percent" />
          <div class="play-time">{{formatterTime(currentTime)}} / {{formatterTime(duration)}}</div>
        </div>
        <audio ref="audio" style="display: none" @timeupdate="playing" src=""></audio>
      </div>
      <div ref="share" class="share-content">
        <!-- <div v-if="!showMore" @click="show" class="show-more">
          <div class="show-shadow"></div>
        </div> -->
        <p
          v-for="(item, index) in resultList"
          v-html="item.text.replace(/(\n)+/g, '<br>')"
          :class="{
            'new-section': item.firstSen,
            'active': activeIndex === index
          }"
          ref="sentenceEl"
          :key="index">
          <!-- {{item.text}} -->
        </p>
      </div>
      <div class="share-footer">
        <div class="download-btn" @click="download">
          <img src="@/assets/img/xiazai.png" srcset="@/assets/img/xiazai@2x.png 2x, @/assets/img/xiazai@3x.png 3x" alt="下载文本">
          <span class="btn-text">下载文本</span>
        </div>
        <div class="footer-text">
          <div class="rec-link">灵云听语官网：<a href="/">rec.aicloud.com</a></div>
          <div class="space"> | </div>
          <div class="page-footer">
            <span>灵云科技</span>
            <span>源自清华</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Slider as VanSlider } from 'vant'
import { isInElementBox } from '../util/index'
// import { saveAs } from 'file-saver'
export default {
  components: {
    VanSlider
  },
  data () {
    return {
      showMore: false,
      priviewText: '',
      showModel: false,
      // 当前播放时间
      currentTime: 0,
      // 是否在播放
      isPlay: false,
      // 识别结果
      resultList: [],
      // 持续时间
      duration: 1,
      activeIndex: 0
    }
  },
  computed: {
    isWeixin () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.includes('micromessenger')
    },
    percent: {
      get () {
        return this.currentTime / this.duration * 100
      },
      set (newVal) {
        const list = this.resultList
        const audio = this.$refs.audio
        const currentTime = audio.currentTime = this.currentTime = this.duration * newVal / 100
        for (let i = 0, len = list.length; i < len; i++) {
          const cur = list[i]
          if (cur.startTime < currentTime && currentTime < cur.endTime) {
            this.activeIndex = i
            break
          }
        }
      }
    }
  },
  watch: {
    activeIndex (val) {
      const activeSentenceEl = this.$refs.sentenceEl[val]
      console.log(activeSentenceEl)
      if (activeSentenceEl instanceof HTMLElement) {
        if (!isInElementBox(activeSentenceEl, this.$refs.share)) {
          // 进行滚动
          this.$refs.share.scrollTo(
            0, activeSentenceEl.getBoundingClientRect().top - this.$refs.share.getBoundingClientRect().top + this.$refs.share.scrollTop
          )
        }
      }
    }
  },
  methods: {
    async getText (code) {
      try {
        const res = await this.$axios.get('/lc/job', { params: { code } })
        const { resultList, audioUrl } = res.data
        this.resultList = this.textToSection(resultList)
        // 设置音频url
        const audio = this.$refs.audio
        audio.src = audioUrl
        audio.addEventListener('canplay', this.getDuration)
      } catch (e) {
        console.log(e)
        Toast('获取文本失败')
      }
    },
    getDuration () {
      this.duration = this.$refs.audio.duration
    },
    // 音频播放
    audioPlay () {
      const audio = this.$refs.audio
      if (this.isPlay) {
        audio.pause()
        this.isPlay = false
      } else {
        audio.play()
        this.isPlay = true
      }
    },
    show () {
      this.showMore = true
      this.$nextTick(() => {
        this.$refs.share.style.overflowY = 'scroll'
      })
    },
    // 找出文本中每一段的第一句
    textToSection (arr) {
      return arr.map((item, index) => {
        if (index === 0 || /(\n|\t)$/.test(arr[index - 1].text)) {
          return {
            ...item,
            firstSen: true
          }
        } else {
          return { ...item }
        }
      })
    },
    formatterTime (time) {
      if (Number(time) < 0) {
        time = 0
      }
      const n = 0
      const formaterNumber = this.formaterNumber
      time = Number(time)
      const second = time % 60
      const minute = (time - second) % (60 * 60) / 60
      const hour = (time - second - minute * 60) / 60 / 60
      return `${formaterNumber(hour)}:${formaterNumber(minute)}:${formaterNumber(second.toFixed(n))}`
    },
    formaterNumber (val) {
      return val >= 10 ? String(val) : `0${val}`
    },
    // 音频播放
    playing () {
      const audio = this.$refs.audio
      const list = this.resultList

      // 当前音频时间
      const currentTime = this.currentTime = audio.currentTime

      // 句子数组长度
      const len = list.length

      // 没有句子，不进行操作
      if (!len) {
        return
      }
      // 当前音频时间早于第一句开始时间，第一句高亮
      if (currentTime < list[0].startTime) {
        this.activeIndex = 0
        return
      }
      // 当前音频时间晚于最后一句结束时间，最后一句高亮
      if (currentTime > list[len - 1].endTime) {
        this.activeIndex = len - 1
        return
      }
      for (let i = 0; i < len; i++) {
        const cur = list[i]
        // 当前音频时间落在某一句区间，这一句高亮
        if (cur.startTime < currentTime && currentTime < cur.endTime) {
          this.activeIndex = i
          return
        } else {
          const next = list[i + 1]
          if (next) {
            // 有下一句，且当前音频时间落在某一句结束时间后及其下一句开始时间前，这一句高亮
            if (currentTime > cur.endTime && currentTime < next.startTime) {
              this.activeIndex = i
              return
            }
          } else {
            // 没有下一句，最后一句高亮
            this.activeIndex = len - 1
            return
          }
        }
      }
    },
    // 下载文本
    download () {
      if (!this.$route.query.jobUid) {
        Toast('下载失败')
        return
      }
      if (this.isWeixin) {
        this.showModel = true
        return
      }
      try {
        const a = document.createElement('a')
        // const href = 'http://10.0.0.46:8182/lc/job/download?fileType=txt&jobUid=MTAwMDAwvmfUwRSgSQsn5JwFO9eTog'
        const href = `/lc/job/download?fileType=txt&jobUid=${this.$route.query.jobUid}`
        a.href = href
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (e) {
        Toast('下载失败')
      }
      // http://10.0.0.203:8080/lc/job/download?fileType=txt&jobUid=MTAwMDAwvrADwBynQCYlIM-q-CsXig
      // http://10.0.0.46:8182/lc/job/download?fileType=txt&jobUid=MTAwMDAwvrADwBynQCYlIM-q-CsXig
      // this.$axios.get('/lc/job/download', {
      //   params: {
      //     fileType: 'txt',
      //     jobUid: this.$route.query.jobUid
      //   },
      //   responseType: 'blob'
      // }).then(res => {
      //   const content = res.headers['content-disposition']
      //   const reg = /filename=(.*)/
      //   let filename = ''
      //   content.replace(reg, (s) => {
      //     filename = s.split('=')[1]
      //     return ''
      //   })
      //   this.downloadFile(res.data, filename)
      // }).catch(e => {
      //   Toast('下载失败')
      // })
    },
    downloadFile (blobData, filename) {
      // const a = document.createElement('a')
      // a.href = 'data:application/octet-stream,' + encodeURIComponent('"My DATA"')
      // a.download = 'myFile.json'
      // a.click()
      // const uriContent = 'data:application/octet-stream,' + encodeURIComponent('"888"')
      // window.open(uriContent, 'a.txt')
      /* 兼容ie内核，360浏览器的兼容模式 */
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const blob = new Blob([blobData])
        window.navigator.msSaveOrOpenBlob(blob, filename)
      } else {
        /* 火狐谷歌的文件下载方式 */
        const blob = new Blob([blobData])
        // saveAs(blob, filename)
        const a = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        // window.open(href)
        if (typeof a.download === 'undefined') {
          window.location.href = href
        } else {
          a.href = href
          a.download = filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
        setTimeout(() => {
          window.URL.revokeObjectURL(href)
        }, 100)
      }
    }
  },
  beforeDestroy () {
    this.$refs.audio.removeEventListener('canplay', this.getDuration)
  },
  created () {
    const code = this.$route.query.code
    if (code) {
      this.getText(code)
    } else {
      Toast('查询不到文本')
    }
  }
}
</script>

<style lang="scss" scoped>
  @media only screen and (-webkit-min-device-pixel-ratio:2) {
    .img-in {
      background-image: url(~@/assets/img/pic_mobile_logo@2x.png);
      background-size: 100% 100%;
    }
  }
  @media only screen and (-webkit-min-device-pixel-ratio:3) {
    .img-in {
      background-image: url(~@/assets/img/pic_mobile_logo@3x.png);
      background-size: 100% 100%;
    }
  }
  @media screen and (max-width: 1199px) {
    .show-more {
      position: absolute;
      width: calc(100vw - 66px);
      text-align: center;
      bottom: 0;
      & .show-shadow {
        height: 160px;
        background-image: linear-gradient(rgba(255, 255, 255, .1), rgba(255, 255, 255, .9));
      }
      & .show-icon {
        background-color: #fff;
      }
    }
    .title-img {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 170px;
      background-color: #6968ff;
      .img-in {
        width: 376px;
        height: 97px;
        margin-left: -40px;
      }
      // background-image: url(~@/assets/img/pic_mobile_logo@3x.png);
      // background-size: 100% 100%;
    }
    .audio-control {
      display: flex;
      height: 160px;
      padding: 39px 32px;
      .play-icon {
        width: 83px;
        height: 83px;
        margin-right: 34px;
        &.play {
          background-image: url(~@/assets/img/btn_mobile_play@3x.png);
          background-size: 100% 100%;
        }
        &.pause {
          background-image: url(~@/assets/img/btn_mobile_pause@3x.png);
          background-size: 100% 100%;
        }
      }
      .play-slider {
        position: relative;
        flex: 1;
        .van-slider {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          height: 10px;
          ::v-deep .van-slider__bar {
            background-color: #6968ff;
          }
        }
        .play-time {
          position: absolute;
          right: 0;
          bottom: 0;
          font-size: 26px;
        }
        ::v-deep .van-slider--disabled {
          opacity: 1;
        }
      }
    }
    .share-content {
      position: relative;
      height: calc(100vh - 170px - 160px - 250px);
      padding: 0 32px;
      background-color: #fff;
      overflow-y: auto;
      text-align: left;
      p {
        display: inline;
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #181818;
        line-height: 42px;
        &.active {
          color: #4342DD;
        }
      }
      .new-section {
        margin-left: 56px;
      }
    }
    .share-footer {
      height: 217px;
      padding: 0 32px;
      .rec-link {
        font-size: 26px;
        color: #999;
        margin-bottom: 15px;
      }
      a {
        text-decoration: none;
        color: #6968FF;
        font-size: 26px;
      }
      .space {
        display: none;
      }
    }
    .download-btn {
      display: flex;
      align-items: center;
      height: 89px;
      margin: 33px 0 32px;
      background-color: #6968FF;
      border-radius: 10px;
      text-align: center;
      justify-content: center;
      img {
        width: 47px;
        height: 39px;
        margin-right: 17px;
      }
      & .btn-text {
        line-height: 60px;
        font-size: 30px;
        color: #fff;
      }
    }
    .page-footer {
      display: flex;
      height: 44px;
      color: #999;
      align-items: center;
      justify-content: center;
      & span {
        font-size: 26px;
        margin-right: 10px;
      }
    }
  }
  @media screen and (min-width: 1200px) {
    .share-page {
      height: 100vh;
      padding: 50Px 0 50Px;/*no*/
      background-image: url(~@/assets/img/bg_share.png);
      background-position: 100% 100%;
      .share-container {
        width: 1200Px;/*no*/
        height: calc(100vh - 100Px);/*no*/
        margin: 0 auto;
      }
    }
    .title-img {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 120Px;/*no*/
      background-color: #6968ff;
      .img-in {
        width: 255Px;/*no*/
        height: 65Px;/*no*/
        background-image: url(~@/assets/img/pic_share_logo.png);
        background-size: 100% 100%;
      }
    }
    .audio-control {
      display: flex;
      height: 64Px;/*no*/
      padding: 16Px 32Px;/*no*/
      background-color: #F3F3FE;
      .play-icon {
        width: 32Px;/*no*/
        height: 32Px;/*no*/
        margin-right: 16Px;/*no*/
        cursor: pointer;
        &.play {
          background-image: url(~@/assets/img/btn_share_play_normal.png);
          background-size: 100% 100%;
          &:hover {
            background-image: url(~@/assets/img/btn_share_play_hover.png);
          }
          &:active {
            background-image: url(~@/assets/img/btn_share_play_pressed.png);
          }
        }
        &.pause {
          background-image: url(~@/assets/img/btn_share_pause_normal.png);
          &:hover {
            background-image: url(~@/assets/img/btn_share_pause_hover.png);
          }
          &:active {
            background-image: url(~@/assets/img/btn_share_pause_pressed.png);
          }
        }
      }
      .play-slider {
        position: relative;
        flex: 1;
        .van-slider {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          height: 5Px;/*no*/
          ::v-deep .van-slider__bar {
            background-color: #6968ff;
          }
        }
        .play-time {
          position: absolute;
          right: 0;
          font-size: 12Px;/*no*/
          bottom: -10Px;/*no*/
        }
        ::v-deep .van-slider--disabled {
          opacity: 1;
        }
        ::v-deep .van-slider__button {
          width: 20Px;
          height: 20Px;
        }
      }
    }
    .share-content {
      height: calc(100vh - 100Px - 304Px);/*no*/
      padding: 0 32Px;/*no*/
      background-color: #fff;
      overflow-y: auto;
      text-align: left;
      p {
        display: inline;
        font-size: 16Px;/*no*/
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 32Px;/*no*/
        &.active {
          background-color: #DCDCFF;
        }
      }
      .new-section {
        margin-left: 32Px;/*no*/
      }
    }
    .share-footer {
      height: 120Px;/*no*/
      padding: 24Px 0 16Px;/*no*/
      text-align: center;
      background-color: #fff;
      .rec-link {
        height: 14Px;
        line-height: 14Px;
        font-size: 14Px;/*no*/
        color: #999;
      }
      a {
        text-decoration: none;
        color: #6968FF;
        font-size: 14Px;/*no*/
      }
      .page-footer {
        display: flex;
        color: #999;
        align-items: center;
        justify-content: center;
        & span {
          font-size: 14Px;/*no*/
          margin-right: 20Px;/*no*/
        }
      }
      .download-btn {
        display: flex;
        align-items: center;
        width: 208Px;/*no*/
        height: 48Px;/*no*/
        margin: 0 auto 20Px;/*no*/
        background-color: #6968FF;
        border-radius: 4Px;/*no*/
        // text-align: center;
        justify-content: center;
        cursor: pointer;
        img {
          display: none;
        }
        & .btn-text {
          line-height: 48Px;/*no*/
          font-size: 16Px;/*no*/
          color: #fff;
        }
      }
      .footer-text {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        margin-bottom: 16Px;/*no*/
        .space {
          margin-right: 20Px;/*no*/
          color: #999;
        }
      }
    }
  }
  .weixinpic {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;
  }
</style>
